import SubcategoryPage from '@/components/template/SubcategoryPage';

const BetonskiUmivalniki = () => {
  const products = [
    {
      title: "Betonski Umivalnik Urban",
      imageSrc: "https://images.unsplash.com/photo-1600566752427-25ef8fb4e018?auto=format&fit=crop&q=80",
      url: "/umivalniki/betonski/urban"
    },
    {
      title: "Betonski Umivalnik Minimalistični",
      imageSrc: "https://images.unsplash.com/photo-1602028915047-37269d1a73f7?auto=format&fit=crop&q=80",
      url: "/umivalniki/betonski/minimalisticni"
    },
    {
      title: "Betonski Umivalnik Industrial",
      imageSrc: "https://images.unsplash.com/photo-1620626011761-996317b8d101?auto=format&fit=crop&q=80",
      url: "/umivalniki/betonski/industrial"
    },
    {
      title: "Betonski Umivalnik Modern",
      imageSrc: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&q=80",
      url: "/umivalniki/betonski/modern"
    },
    {
      title: "Betonski Umivalnik Kvadrat",
      imageSrc: "https://images.unsplash.com/photo-1617004518200-f3b8191fdc1d?auto=format&fit=crop&q=80",
      url: "/umivalniki/betonski/kvadrat"
    },
    {
      title: "Betonski Umivalnik Premium",
      imageSrc: "https://images.unsplash.com/photo-1600566752610-111d521cf1de?auto=format&fit=crop&q=80",
      url: "/umivalniki/betonski/premium"
    }
  ];

  return (
    <SubcategoryPage
      title="Betonski Umivalniki"
      description="Občudujte našo kolekcijo trpežnih betonskih umivalnikov, ki v vašo kopalnico vnesejo industrijski šarm in sodoben minimalizem. Naravna tekstura in trpežnost betona ponujata edinstven estetski izgled z dolgo življenjsko dobo."
      heroImage="https://images.unsplash.com/photo-1600566752427-25ef8fb4e018?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default BetonskiUmivalniki;